import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const fontStyle = {
	fontFamily: 'Open Sans, sans-serif',
	fontWeight: 'normal',
	fontStyle: 'normal',
	fontSize: '14px',
	lineHeight: '19px',		
};

const inputFieldBorderActive = '#2888c3';
const inputFieldBorderDefault = 'rgba(0, 0, 0, 0.23)';

function getColorStyles(isFocused) {
	// Documentation for props https://react-select.com/props
	return {
		control: (styles) => ({
			...styles,
			...fontStyle, 
			backgroundColor: 'white',
			boxShadow: 'none',
			borderColor: isFocused ? inputFieldBorderActive : inputFieldBorderDefault,
			'&:hover': {
				borderColor: inputFieldBorderActive
			}
		}),
		option: (styles, { isDisabled, isFocused, isSelected }) => {
		
			return {
				...styles,
				...fontStyle,
				textAlign: 'left',

				backgroundColor: isDisabled
					? undefined
					: isSelected
						? 'rgba(47, 165, 231, 0.30)'
						: isFocused
							? 'rgba(47, 165, 231, 0.30)'
							: undefined,

				color: isDisabled
					? '#ccc'
					: '#2E3F4F',

				cursor: isDisabled ? 'not-allowed' : 'default',
			};
		},
		input: (styles) => ({ ...styles }),
		placeholder: (styles) => ({ ...styles, ...fontStyle }),
		singleValue: (styles) => ({ ...styles }),
		noOptionsMessage: (styles) => ({ ...styles, ...fontStyle }),
	};
}


class ReactSelect extends Component {

	constructor(props) {
		super(props);

		this.state = {
			controlFocused: false,
		};	
	}

	handleChange = (newValue) => {
		this.props.onChangeHandler(newValue);
	}	

	onMenuOpen = () => {
		this.setState({ controlFocused: true });
	}	

	onMenuClose = () => {
		this.setState({ controlFocused: false });
	}	

	render() {
		return (
			<Select
				onMenuOpen={this.onMenuOpen}
				onMenuClose={this.onMenuClose}
				value={this.props.value}
				onChange={this.handleChange}
				options={
					this.props.options.map((item) => {
						if (!item.label) {
							item.label = item.value;
						}
						return item;
					})
				}
				placeholder={this.props.placeholder}
				styles={getColorStyles(this.state.controlFocused)}		
				isDisabled={this.props.isDisabled}
			/>
		);
	}
}

ReactSelect.propTypes = {
	options: PropTypes.array.isRequired,
	placeholder: PropTypes.string,
	classes: PropTypes.object,
	onChangeHandler: PropTypes.func,
	value: PropTypes.object,
	isDisabled: PropTypes.bool,
};

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/components/ReactSelect/index.js